import { Fragment, useContext, useMemo } from 'react';
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import { makeStyles } from 'tss-react/mui';
import MenuItem from './menuItem';
import { AuthContext } from '../../../context/auth';
import People from '@mui/icons-material/People';
import DashboardIcon from '@mui/icons-material/Dashboard';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssessmentIcon from '@mui/icons-material/Assessment';

const useStyles = makeStyles()((theme) => ({
    container: {
        overflow: "hidden auto",
        margin: "8px 0",
    },
    headerExpandible: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundImage: "linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05))",
        paddingLeft: "55px",
    },
    divider: {
        margin: "8px 0",
    }
}));

export default function Main() {
    const { usuario } = useContext(AuthContext);
    const { classes } = useStyles();

    const isAdmin = useMemo(() => {
        if (!usuario) return false;
        return usuario.es_admin === true || usuario.nivel_usuario === 1 || usuario.sup_usuarios === true;
    }, [usuario]);

    const esPublico = useMemo(() => {
        return usuario?.establecimiento?.tipo === 'publico';
    }, [usuario]);

    const isUsuariosDisabled = useMemo(() => {
        if (!usuario) return true;
        return !(usuario.nivel_usuario === 1 || usuario.sup_usuarios === true);
    }, [usuario]);

    // Admin: todo + Auditoría
    // Operario público: pacientes + órdenes
    // Privado: solo hub de órdenes
    const menuItems = [
        {
            label: "Inicio",
            visible: !!usuario,
            items: [
                {
                    label: "Panel de Inicio",
                    icon: DashboardIcon,
                    url: "/dashboard",
                    visible: true,
                    disabled: false,
                    list: []
                },
            ],
        },
        {
            label: "Operación",
            visible: !!usuario,
            items: [
                {
                    label: "Pacientes",
                    icon: PersonIcon,
                    url: "/paciente",
                    visible: isAdmin || esPublico,
                    disabled: false,
                    list: []
                },
                {
                    label: "Órdenes de práctica",
                    icon: AssignmentIcon,
                    url: "/orden-practica",
                    visible: true,
                    disabled: false,
                    list: []
                },
            ],
        },
        {
            label: "Prácticas y establecimientos",
            visible: isAdmin,
            items: [
                {
                    label: "Prácticas",
                    icon: MedicalServicesIcon,
                    url: "/practica",
                    visible: true,
                    disabled: false,
                    list: []
                },
                {
                    label: "Establecimientos",
                    icon: BusinessIcon,
                    url: "/establecimiento",
                    visible: true,
                    disabled: false,
                    list: []
                },
            ],
        },
        {
            label: "Sistema",
            visible: isAdmin,
            items: [
                {
                    label: "Usuarios",
                    icon: People,
                    url: "/usuario",
                    visible: true,
                    disabled: isUsuariosDisabled,
                    list: []
                },
                {
                    label: "Auditoría",
                    icon: AssessmentIcon,
                    url: "/auditoria",
                    visible: true,
                    disabled: false,
                    list: []
                },
            ],
        },
    ];

    return (
        <div className={classes.container}>
            { menuItems.map((seccion) => (
                seccion.visible ?
                    <Fragment key={`seccion-${seccion.label}`}>
                        <ListSubheader inset className={classes.headerExpandible}> {seccion.label} </ListSubheader>

                        {seccion.items.map((item) => (
                            item.visible ?
                                <Fragment key={`item-${item.url || item.label}`}>
                                    <MenuItem url={item.url} label={item.label} Icon={item.icon} disabled={item.disabled} />
                                    <List component="div" disablePadding>
                                        { item.list.map((subitem) => (
                                            subitem.visible ?
                                                <MenuItem
                                                    key={`subitem-${(item.url || '') + (subitem.url || subitem.label)}`}
                                                    url={(item.url || '') + (subitem.url || '')}
                                                    label={subitem.label}
                                                    Icon={subitem.icon}
                                                    disabled={subitem.disabled}
                                                    sx={{ pl: 7 }}
                                                />
                                            : null
                                        ))}
                                    </List>
                                </Fragment>
                            : null
                        ))}
                    </Fragment>
                : null
            ))}
        </div >
    );
}
